export { SharedNavBreadcrumb } from './nav_breadcrumb'
